import React, { useState } from "react";
import SideBar from "../../components/sidebar/Sidebar";
import "./Beni.scss";
import AddIcon from "@mui/icons-material/Add";
import { Box, Fab, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BeneUbicazioneTableComponent from "../../components/bene/ubicazione/BeneUbicazioneTableComponent";

const BeneUbicazionePage: React.FC<{}> = () => {
  const [fabVisible, setFabVisible] = useState(true);

  return (
    <div className="home">
      {fabVisible && (
        <Fab
          onClick={() => setFabVisible(false)}
          sx={{ position: "fixed", bottom: 16, right: 16 }}
          color="primary"
          aria-label="add"
        >
          <AddIcon />
        </Fab>
      )}
      <SideBar />
      <div className="homeContainer">
        <Box sx={{ mb: 3 }}>
          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: 2,
            mb: 2,
            pb: 2,
            borderBottom: "2px solid",
            borderColor: "primary.main"
          }}>
            <LocationOnIcon sx={{ fontSize: 40, color: "primary.main" }} />
            <Typography 
              variant="h4" 
              sx={{ 
                fontWeight: 600,
                color: "primary.main",
                letterSpacing: "0.5px"
              }}
            >
              Ubicazioni
            </Typography>
          </Box>
        </Box>
        <BeneUbicazioneTableComponent
          alterFabVisibility={setFabVisible}
          fabVisible={fabVisible}
          enableCreate={true}
        />
      </div>
    </div>
  );
};

export default BeneUbicazionePage;
